import { render, staticRenderFns } from "./ListArticleListItem.vue?vue&type=template&id=85fe0db8&scoped=true"
import script from "./ListArticleListItem.vue?vue&type=script&setup=true&lang=ts"
export * from "./ListArticleListItem.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./ListArticleListItem.vue?vue&type=style&index=0&id=85fe0db8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85fe0db8",
  null
  
)

export default component.exports